import { apiRequestActions } from '@ackee/redux-utils';
import { fetchUsersTypes } from './types';

export default apiRequestActions(fetchUsersTypes);
